import styled from 'styled-components'

export const Container = styled.div`
  .VictoryContainer {
    svg {
      height: 300px !important;
    }
  }
`
